module.exports = __webpack_public_path__ + "img/info.dc2f9da8.png";